import { useStopwatch } from "react-timer-hook";

type Params = {
    offsetTimestamp: Date;
}

const MyTimer = ({ offsetTimestamp }: Params) => {
    const { minutes, hours } = useStopwatch({ autoStart: true, offsetTimestamp });

    return (
        <strong>
            {hours}h{minutes}min
        </strong>
    );
}

export default MyTimer;